export const money = (n) => (n == null ? "--" : `$${Number(n).toFixed(2)}`);
export const num = (n) => (n == null ? "--" : Number(n).toLocaleString());
export const pct = (n) => (n == null ? "--" : `${n >= 0 ? "+" : ""}${Number(n).toFixed(1)}%`);
